module.exports = "/static/assets/5b3e93a54812411820707a52775f408d.png";